// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dropzone-custom {
  border: 1px solid #0A56AE;
  border-radius: 20px;
  padding: 0;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
}

.upload-icon {
  color: #697483;
}

.upload-div {
  border: 1px solid lightgray;
  border-radius: 8px;
  width: 35px;
  height: 35px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 10px;
}

.upload-span {
  font-weight: 500;
  color: purple;
}

.uploaded-files-div {
  border: 1px solid lightgray;
  border-radius: 8px;
  padding: 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
}`, "",{"version":3,"sources":["webpack://./../common/src/Components/DynamicForm/formelements/DragDropFilesElements.scss"],"names":[],"mappings":"AAAA;EACI,yBAAA;EACA,mBAAA;EACA,UAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AACJ;;AAEA;EACI,cAAA;AACJ;;AAEA;EACI,2BAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;AACJ;;AAEA;EACI,gBAAA;EACA,aAAA;AACJ;;AAEA;EACI,2BAAA;EACA,kBAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;AACJ","sourcesContent":[".dropzone-custom {\n    border: 1px solid #0A56AE;\n    border-radius: 20px;\n    padding: 0;\n    text-align: center;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.upload-icon {\n    color: #697483\n}\n\n.upload-div {\n    border: 1px solid lightgray;\n    border-radius: 8px;\n    width: 35px;\n    height: 35px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin-bottom: 10px;\n}\n\n.upload-span {\n    font-weight: 500;\n    color: purple;\n}\n\n.uploaded-files-div {\n    border: 1px solid lightgray;\n    border-radius: 8px;\n    padding: 10px;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    margin-bottom: 10px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
